import { useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { memo } from "react";
import { useDashboardView } from "../../../../../store/contexts/DashBoardViewContext";
import { DashboardGrid } from "../DashboardGrid/DashboardGrid";
import { DashboardList } from "../DashboardList/DashboardList";

export const DashboardViewContainer = memo(() => {
  const { viewMode } = useDashboardView();

  const theme = useTheme();

  const matches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <motion.div
      key={viewMode}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.6, -0.05, 0.01, 0.99] }}
      style={{
        height:
          viewMode === "grid"
            ? matches
              ? "calc(100vh - 16rem)"
              : "calc(100vh - 12rem)"
            : "95%",
      }}
    >
      {viewMode === "list" && <DashboardList />}
      {viewMode === "grid" && <DashboardGrid />}
    </motion.div>
  );
});
